export default defineNuxtRouteMiddleware(to => {
    // Only run on client-side to avoid SSR conflicts
    if (process.client) {
        // Skip redirect if already has trailing slash
        if (to.path.endsWith('/')) {
            return;
        }

        // Handle /nl without trailing slash
        if (to.path === '/nl') {
            return navigateTo('/nl/', { redirectCode: 301 });
        }

        // Handle other paths that should have trailing slashes
        // Add paths that should have trailing slashes here
        // For example: if (to.path === '/some-other-path') { ... }
    }
});
